import { Component, OnInit, Input } from '@angular/core';

  import {visibilityPanelAnimation} from '../../classes/visibility-panel.animation'
  
import {StreamsService}  from "../../services/streams.service";
 import {PanelVisibilityService} from '../../services/panel-visibility.service'
 import {StreamProject} from "../../interfaces";
 import {   NbToastrService , NbGlobalPosition} from '@nebular/theme';

@Component({
  selector: 'subtitles-control',
  templateUrl: './subtitles-control.component.html',
  styleUrls: ['./subtitles-control.component.scss'],
  animations: [visibilityPanelAnimation]
})
export class SubtitlesControlComponent implements OnInit {

  @Input() stream: StreamProject = null;
  
  
  isEnabled:boolean = false;
  items = [];
  selectedId = false;
  subscribeToggleEnable$ = null;
    loadingToggle:boolean = false
  
  constructor(
  
    public streamsService: StreamsService,
    private toastrService: NbToastrService,
    public panelVisibility: PanelVisibilityService
  ) { 

  }
  
  ngOnInit(): void { 
       this.isEnabled =  this.stream.enabledSubtitles
       this.items = [...this.stream.subtitles]
       
  }
  
  
  
  toggleEnabled(){
     if(this.isEnabled){
           this.setEnabled(true)
	}else{
          this.setEnabled(false)
	}
  }
  
  
    setEnabled(enabled){
    
    
    
    this.loadingToggle = true

	if( this.subscribeToggleEnable$){
      this.subscribeToggleEnable$.unsubscribe()
     }
    this.subscribeToggleEnable$ = this.streamsService.updateSubtitlesEnable(this.stream._id, enabled).subscribe((stream: StreamProject)=>{
    
            this.stream.enabledSubtitles = stream.enabledSubtitles
		this.isEnabled = stream.enabledSubtitles
  
      this.loadingToggle = false
    },(error)=>{
      this.loadingToggle = false
  
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }


  
  
  
  addItem(){
  
  
    let id = this.stream.publicIdentity + Math.random() + "" + new Date().getTime();
  
    
    
    	
    
       this.streamsService.updateSubtitles(this.stream._id, {createItem:true, identity:id}).subscribe((res: any)=>{
     		 
     		 
     		 this.items.push({
		    	identity:  id,
		    	title: "",
		    	file: ""
		    
		    })
		    this.stream.subtitles.push({
		    	identity:  id,
		    	title: "",
		    	file: ""
		    
		    })
		  
    },(error)=>{	
    
       
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
    
  }
  
  setUploadIdentity(id){
  	 this.selectedId = id;
  }
  
  titleChanged(id, e){
  
   let data = {
   	identity: id,
   	title: e.target.value
   }
   //console.log(data)
  
  
     this.streamsService.updateSubtitles(this.stream._id, data).subscribe((res: any)=>{
     		 
     		
       let oldEl = this.stream.subtitles.find(i=>i.identity === id)
       
       if(oldEl){
        oldEl.title = data.title
       }
    },(error)=>{	
         let oldEl = this.stream.subtitles.find(i=>i.identity === id)
       
       if(oldEl){
        e.target.value = oldEl.title
       }
  
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }
  
  
  
  removeFile(id){
  
  
  	
       this.streamsService.updateSubtitles(this.stream._id, {removeFile:true, identity:id}).subscribe((res: any)=>{
     		 
     		     var item =  (this.stream.subtitles.find(i=>i.identity === id))
     		     if(item) item.file = ""
     		     
            	      item = (this.items.find(i=>i.identity === id)) 
            	     if(item) item.file = ""
       
		  
    },(error)=>{	
    
       
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  
  
  }
  
  deleteItem(id){

  	
  	
       this.streamsService.updateSubtitles(this.stream._id, {deleteItem:true, identity:id}).subscribe((res: any)=>{
     		 
     		   	this.items = this.items.filter(i=>i.identity !== id)
     		   	 this.stream.subtitles = this.stream.subtitles.filter(i=>i.identity !== id)
     		 
		  
    },(error)=>{	
    
       
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
    
  }
  
  uploadFile(e){
  
  
  	//console.log(e)
  	let item = this.items.find(i=>i.identity === this.selectedId)
  	
  	    const formData = new FormData()
      formData.append('identity', item.identity)
    formData.append('publicIdentity', this.stream.publicIdentity)
       
      formData.append('file',e.files[0], e.files[0].name)
    this.streamsService.updateSubtitles(this.stream._id, formData).subscribe((res: any)=>{
     		 
     		   	item.file = res.resp.file;
     		    
     		   	// this.srteam.subtitles = this.srteam.subtitles.filter(i=>i.identity !== id)
     		 
		  
    },(error)=>{	
   
       
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  	//item.file = "s,,s"
  	  //	console.log(item)
  }
 
  
   ngOnDestroy() { 
    if( this.subscribeToggleEnable$){
      this.subscribeToggleEnable$.unsubscribe()
     } 
   }
 


}
